import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "aos/dist/aos.css";
import { tg_title_animation } from "./lib/gsap/tg_title_animation";
import { useParticles } from "./lib/hooks/useParticles";
import { useParallax } from "./lib/hooks/useParallax";
import { useHasAnimation } from "./lib/hooks/useHasAnimation";
import { useWow } from "./lib/hooks/useWow";
import { useAos } from "./lib/hooks/useAos";
import { useJarallax } from "./lib/hooks/useJarallax";

import HomeFive from "./pages/Home/HomeFive";
import AboutPageFive from "./pages/About/AboutPageFive";
import ServicesPageFive from "./pages/Services/ServicesPageFive";
import ServicesDetailsPageFive from "./pages/ServicesDetails/ServicesDetailsPageFive";
import BlogPage from "./pages/BlogPages/BlogPage";
import BlogDetailsPage from "./pages/BlogPages/BlogDetailsPage";
import ContactPage from "./pages/Contact/ContactPage";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicy/PrivacyPolicyPage";

function App() {
  useWow();
  useAos();
  useJarallax();
  useParallax();
  useParticles();
  useHasAnimation();

  useEffect(() => {
    tg_title_animation();
  }, []);

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<HomeFive />} />
      <Route path="/about" element={<AboutPageFive />} />
      <Route path="/services" element={<ServicesPageFive />} />
      <Route path="/services/:slug" element={<ServicesDetailsPageFive />} />
      <Route path="/services-details" element={<Navigate to="/services/secp-services" replace />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogDetailsPage />} />
      <Route path="/blog-details" element={<Navigate to="/blog" replace />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

      <Route path="/home-2" element={<Navigate to="/" replace />} />
      <Route path="/home-3" element={<Navigate to="/" replace />} />
      <Route path="/home-4" element={<Navigate to="/" replace />} />
      <Route path="/home-5" element={<Navigate to="/" replace />} />
      <Route path="/about-2" element={<Navigate to="/about" replace />} />
      <Route path="/about-3" element={<Navigate to="/about" replace />} />
      <Route path="/about-4" element={<Navigate to="/about" replace />} />
      <Route path="/about-5" element={<Navigate to="/about" replace />} />
      <Route path="/services-2" element={<Navigate to="/services" replace />} />
      <Route path="/services-3" element={<Navigate to="/services" replace />} />
      <Route path="/services-4" element={<Navigate to="/services" replace />} />
      <Route path="/services-5" element={<Navigate to="/services" replace />} />
      <Route path="/services-details-2" element={<Navigate to="/services-details" replace />} />
      <Route path="/services-details-3" element={<Navigate to="/services-details" replace />} />
      <Route path="/services-details-4" element={<Navigate to="/services-details" replace />} />
      <Route path="/services-details-5" element={<Navigate to="/services-details" replace />} />

      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
